var _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1311,
    height: 151,
    viewBox: "0 0 1311 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.5,
    cy: 407,
    rx: 1105.5,
    ry: 407,
    fill: "#B3CEC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.17abb1f06831e7708abc088fa480f722.svg";
export { ForwardRef as ReactComponent };